@if (isVisible) {
<button class="_round-button inline-flex box-shadow-1"
        [class._saved]="isCurrentOutfitSaved"
        [class._busy]="saveStatus.busy"
        (click)="saveOutfit()"
        [disabled]="saveStatus.busy">
    <span class="p2">{{ getSaveTooltipText() | translate }}</span>
    @if (saveStatus.busy) {
    <i class="_icon icon-loading"></i>
    }
    @if (saveStatus.error) {
    <tooltip [position]="'top-right'"
             [lightMode]="true"
             [ngStyle]="{ opacity: saveStatus.error ? 1 : 0 }">
        <result [status]="saveStatus"></result>
    </tooltip>
    }
</button>
}
